import { CarouselItemViewModel, ComponentType } from '@/types/cml-api';
import { AppNextLink } from '@/features/app-next-link';
import LazyImage from '@/features/image/lazy-image';
import { Webengage } from '@/features/webengage';
import { useDataLayerPush } from '../../../_utils/use-datalayer-push';
import { DataLayerProps, IsLoadingLazyProps } from '../../type';
import { elementTrackingId } from '../contants';
interface Props extends IsLoadingLazyProps, CarouselItemViewModel, DataLayerProps {}
export default function CarouselBrandItem({
  link,
  isLazy,
  index,
  id,
  desktopImageUrl,
  title,
  sortKey,
  componentId
}: Props) {
  const pushToDataLayer = useDataLayerPush();
  const handleClick = () => {
    pushToDataLayer({
      event: elementTrackingId,
      elementType: ComponentType.CarouselBrand,
      elementIndex: index || 0,
      itemID: id || '',
      elementName: sortKey,
      destinationUrl: link || '',
      componentId,
      ImageUrl: desktopImageUrl || null
    });
    Webengage.trackCtaAction({
      banner_type: ComponentType.CarouselBrand,
      banner_name: sortKey ?? '',
      banner_index: index?.toString() || '0',
      url_destination: link || '',
      item_id: id || '',
      component_id: componentId ?? '',
      image_url: desktopImageUrl ?? ''
    });
  };
  return <AppNextLink onClick={handleClick} key={id || link} aria-label={title || 'brand-image'} href={link || ''} prefetch={false} className='flex w-[86px] items-center justify-center lg:w-52' data-sentry-element="AppNextLink" data-sentry-component="CarouselBrandItem" data-sentry-source-file="carousel-brand-item.tsx">
            <LazyImage src={desktopImageUrl || ''} alt={title || 'brand-image'} className='h-12 w-[86px] object-contain lg:h-16 lg:w-52' loaderClassName='w-full lg:w-4/5 rounded' isLazy={isLazy} data-sentry-element="LazyImage" data-sentry-source-file="carousel-brand-item.tsx" />
        </AppNextLink>;
}